import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export var SET_WISHLIST_ITEMS = 'SET_WISHLIST_ITEMS';
export var ADD_WISHLIST_ITEM = 'ADD_WISHLIST_ITEM';
export var DELETE_WISHLIST_ITEM = 'DELETE_WISHLIST_ITEM';
export var SET_WISHLIST_PRODUCTS = 'SET_WISHLIST_PRODUCTS';